import React from "react";
import { components } from "react-select";

const getReactSelectStyling = ({
    showError = false,
    isMultiSelect = false,
    height = "2.075rem",
    includeMenuStyle = true,
    valueContainerStyle = true,
    disabledCustomStyling = true,
    additionalStyles = {},
} = {}) => {
    return {
        control: (styles, { isFocused, isDisabled }) => ({
            ...styles,
            color: isDisabled ? "#5d5d5d" : styles.color,
            borderColor: showError && !isFocused ? "#ffb300" : "#ced4da",
            "&:hover": {
                borderColor: showError && !isFocused ? "#ffb300" : "#ced4da",
            },
            border: isDisabled ? "1px solid #ced4da" : undefined,
            borderRaduis: "0.25rem",
            minHeight: height,
            height: isMultiSelect ? "auto" : height,
            alignContent: "center",
            ...(disabledCustomStyling && {
                backgroundColor: isDisabled ? "#e9eff6" : undefined,
                fontSize: isDisabled ? 12.8 : null,
            }),
        }),
        menu: (provided) =>
            includeMenuStyle
                ? {
                      ...provided,
                      zIndex: 99,
                      color: "#33394e",
                  }
                : provided,
        menuPortal: (base) => ({ ...base, zIndex: 999 }),
        valueContainer: (provided) =>
            valueContainerStyle
                ? {
                      ...provided,
                      textOverflow: "ellipsis",
                      maxWidth: "90%",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                  }
                : provided,
        placeholder: (provided) => ({
            ...provided,
            textOverflow: "ellipsis",
            maxWidth: "85%",
            overflow: "hidden",
        }),
        ...additionalStyles,
    };
};

const getReactSelectSmallStyling = (includeMenuStyle = true, height = 30) => {
    return {
        control: (base) => ({
            ...base,
            height,
            minHeight: height,
            alignContent: "center",
        }),
        menu: (provided) =>
            includeMenuStyle
                ? {
                      ...provided,
                      position: "relative",
                      zIndex: 99,
                  }
                : provided,
    };
};

const getShortSelectMenu = () => {
    return {
        Menu: (props) => (
            <components.Menu {...props} className="parameter-unit-menu" />
        ),
        MenuList: (props) => (
            <components.MenuList {...props} className="parameter-unit-menu" />
        ),
    };
};

const getReactSelectTheme = (theme) => ({
    ...theme,
    colors: {
        ...theme.colors,
        primary25: "#e9eff6",
        primary: "#3D4871",
    },
});

export {
    getReactSelectStyling,
    getReactSelectTheme,
    getReactSelectSmallStyling,
    getShortSelectMenu,
};
